module.exports = __webpack_public_path__ + "assets/img/img40.0d1980e2.png";